import { useTranslate } from "@similarweb/i18n-provider";
import { OpenFolder, Settings, SocialEmail, User } from "@similarweb/icons";
import { Button } from "@similarweb/ui-components";
import { Stack } from "@similarweb/ui-components/foundations";

import {
    EMPTY_COMPANY_NAME,
    EMPTY_COMPETITORS_COUNT,
    WORLDWIDE,
} from "app/pages/activation/components/HomeWithData/constants";
import { projectsDataAutomation } from "app/pages/activation/components/HomeWithData/dataAutomationKeys";
import * as SC from "app/pages/activation/components/HomeWithData/ProjectItem/styles";
import { COMPETITORS_TEXT } from "app/pages/activation/components/HomeWithData/Projects/texts";
import { CREATE_PROJECT } from "app/pages/activation/components/HomeWithData/texts";

type EmptyItemSchema = {
    onClick: () => void;
};

export const EmptyItem = ({ onClick }: EmptyItemSchema) => {
    const { translate } = useTranslate();

    return (
        <SC.EmptyProjectContainer data-automation={projectsDataAutomation.emptyProjectItem}>
            <SC.IconContainer>
                <OpenFolder size="xs" />
            </SC.IconContainer>

            <Stack>
                <SC.NameText fontVariant="chip1TopRow">{EMPTY_COMPANY_NAME}</SC.NameText>

                <SC.InfoContainer>
                    <SC.CompetitorsText fontVariant="dataTable2">
                        {translate(COMPETITORS_TEXT, { count: EMPTY_COMPETITORS_COUNT })}
                    </SC.CompetitorsText>

                    <User size="xs" />

                    <SC.StyledCountryIcon
                        countryCode={WORLDWIDE}
                        size="xs"
                        className="emptyItemCountry"
                    />

                    <SC.Splitter />

                    <SocialEmail size="xs" />

                    <Settings size="xs" />
                </SC.InfoContainer>
            </Stack>

            <Button onClick={onClick}>{translate(CREATE_PROJECT)}</Button>
        </SC.EmptyProjectContainer>
    );
};
